import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class PaymentModel extends Model {
  static reducer(action, PaymentModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Payment.schema:
        action.payload.forEach((payload) => {
          const dbData = PaymentModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          PaymentModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
PaymentModel.modelName = "PaymentModel";

PaymentModel.fields = {
  id: attr(),
};

export default PaymentModel;